import { useAppContext } from 'AppContext';
import React from 'react'

import { AiFillCheckCircle, AiFillCloseCircle } from "react-icons/ai";
import { ImSigma } from "react-icons/im";


import Graph from 'Graph'


const SummaryPanel = () => {
    const { data, accepted, threshold, setThreshold } = useAppContext()

    const computePercentage = () => {
        return Math.round((accepted / data.length) * 100)
    }

    return (
        <div className="flex flex-col">
            <p className="text-center text-2xl text-thin py-4">Batch Summary</p>


            <div className="flex">
                <p className="flex-auto ml-2"></p>
                <p className="text-8xl text-bold">{computePercentage()}</p>
                <div className="flex flex-auto text-3xl pb-2 pl-2 items-end">
                    <p>%</p>
                </div>
            </div>

            <p className="text-center">Acceptance Rate</p>

            <div className="flex justify-center mt-2">
                <div className="flex justify-center items-center text-lg">
                    <AiFillCheckCircle />
                    <p className="pl-2 w-12">{accepted}</p>
                </div>

                <div className="flex justify-center items-center text-lg">
                    <div className="text-red-400 m-0 p-0">
                        <AiFillCloseCircle />
                    </div>
                    <p className="pl-2 w-12">{data.length - accepted}</p>
                </div>

                <div className="flex justify-center items-center text-lg">
                    
                    <div className="text-sm">
                        <ImSigma />
                    </div>
                    <p className="pl-2 w-12">{data.length}</p>
                </div>
            </div>

            <p className="text-center mt-12 less-bottom">Last Samples Overview</p>
        
            <Graph xValues={data.map((_, i) => i)} yValues={data.map((obj, _) => obj.scratch)}
                threshold={threshold} onThresholdChange={(t) => setThreshold(t)}
            />

        </div>
    )
}

export default SummaryPanel
